module.exports = __webpack_public_path__ + "media/images/sunfix_logo_gray-db05227729f849ef9845c4c03afc3102.svg";